// extracted by mini-css-extract-plugin
module.exports = {"StatusInfoPanel":"StatusInfoPanel_StatusInfoPanel__2Xazv","col":"StatusInfoPanel_col__vFDzx"};